/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages

 
var ig = {};
// !!! USE YOUR OWN TOKEN
ig.token = '4969251657.f5a3a13.57e8b9491f2a45aa97fd17b8f2bcffe0';

ig.init = function() {
  $('.instagram').each(function(i) {
    var args = {};
    args.container = $(this);
    args.userid = args.container.data('userid');
    args.limit = args.container.data('limit');
    args.feedurl = 'https://api.instagram.com/v1/users/self/media/recent/?access_token='+ig.token+'&count='+args.limit+'&callback=?';
    args.html = '';
    // PASS ARGS TO QUERY
    ig.query(args);
  });
}

ig.query = function(args) {
  $.getJSON(args.feedurl, {}, function(data) {
		// PASS QUERY DATA TO BUILDER
		ig.build(data, args);
	});
}


ig.build = function(data, args) {
  
  $.each(data.data,function (i,item) {
    console.log(item);
    if (item.caption) var caption = item.caption.text;
    var thumb = item.images.low_resolution.url;
    var img = item.images.standard_resolution.url;
    //get 1280 size photo [hack until avail in api]
    var hires = img.replace('s640x640', '1080x1080');
    args.html += '<a class="image col-xs-3 col-sm-3" style="background-image: url('+thumb+');" data-img="'+hires+'">';
    if (caption) args.html += '<span class="caption">'+caption+'</span>';
    args.html += '</a>';
    // PASS TO OUTPUT
    ig.output(args);
  });
}

ig.output = function(args) {
  args.container.html(args.html);
}

ig.view = {
  viewer: $('.igviewer'),
  image: $('.igviewer img'),
  open: function(img) {
    ig.view.viewer.removeClass('hidden');
    ig.view.image.attr('src', img); 
  },
  close: function() {
    ig.view.viewer.addClass('hidden');
    ig.view.image.attr('src', ''); 
  }
}

ig.init();

//Listeners
$('.instagram').on('click', '.image', function(){
  var img = this.dataset.img;
  ig.view.open(img);
});
$('.igviewer').on('click', function(){
  ig.view.close();
});
          
          
//Listeners
$('.instagram').on('click', '.image', function(){
  var img = this.dataset.img;
  ig.view.open(img);
});
$('.igviewer').on('click', function(){
  ig.view.close();
});
          
$('.hamburger-menu').on('click', function() {
    $('.bar').toggleClass('animate');
    $('.nav-primary').toggleClass('active'); 
});
    
          

$(window).load(function(){ 
    setTimeout(function(){
        $('.gd-loader').fadeOut();
    }, 100);
});   
     
$(window).load(function(){ 
    setTimeout(function(){
        $('.overlay-content').fadeIn(2000);
    }, 1200);
});        
    
          
          
          
$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 400) {
        $(".banner").addClass("stick");
    }
    else {
        $(".banner").removeClass("stick-top");
    }
});
      
// Scroll Reveal
window.sr = ScrollReveal({
    //reset: true,
    opacity: 0,
    scale: 1,
    duration: 1000,
    distance: '100px',
    mobile: false,
    viewFactor: 0.4
});
sr.reveal('.fadein');
          
          
$('a[rel="relativeanchor"], .smoothscroll').click(function(){
    $('html, body').animate({
        scrollTop: $( $.attr(this, 'href') ).offset().top
    }, 800);
    return false;
});  
       

          
           
// Google Map
$( document ).ready( function() {

  
	//Google Maps JS
	//Set Map
	function initialize() {
			var myLatlng = new google.maps.LatLng(39.141330, -84.391766);
			var imagePath = 'http://m.schuepfen.ch/icons/helveticons/black/60/Pin-location.png'
			var mapOptions = {
				zoom: 14,
                scrollwheel: false,
				center: myLatlng,
				mapTypeId: google.maps.MapTypeId.ROADMAP
			}

		var map = new google.maps.Map(document.getElementById('map'), mapOptions);
		//Callout Content
		var contentString = '<h3>5729 Dragon Way<br>Cincinnati, Ohio 45227 USA</h3><a href="https://www.google.com/maps/place/5729+Dragon+Way,+Cincinnati,+OH+45227" target="_blank>Directions</a>';
		//Set window width + content 
		var infowindow = new google.maps.InfoWindow({
			content: contentString,
			maxWidth: 500
		});

		//Add Marker
		var marker = new google.maps.Marker({
			position: myLatlng,
			map: map,
			icon: imagePath,
			title: 'image title'
		});

		google.maps.event.addListener(marker, 'click', function() {
			infowindow.open(map,marker);
		});

		//Resize Function
		google.maps.event.addDomListener(window, "resize", function() {
			var center = map.getCenter();
			google.maps.event.trigger(map, "resize");
			map.setCenter(center);
		});
	}

	google.maps.event.addDomListener(window, 'load', initialize);

});
          

var $status = $('.pagingInfo');
var $slickElement = $('.services-slider');

$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + '/' + slick.slideCount);
});

// Intro Slider
$(".services-slider").slick({
    // autoplay: true,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
    appendArrows: $('.arrows'),
    responsive: [{ 
    breakpoint: 480,
    settings: {
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
    } 
    }]
});    
         
var $status_2 = $('.pagingInfo_2');
var $slickElement_2 = $('.projects-slider');

$slickElement_2.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
    //currentSlide is undefined on init -- set it to 0 in this case (currentSlide is 0 based)
    var i = (currentSlide ? currentSlide : 0) + 1;
    $status_2.text(i + '/' + slick.slideCount);
});

// Intro Slider
$slickElement_2.slick({
    // autoplay: true,
    dots: false,
    arrows: true,
    adaptiveHeight: true,
    appendArrows: $('.arrows_2'),
    responsive: [{ 
    breakpoint: 480,
    settings: {
        dots: false,
        arrows: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
    } 
    }]
}); 	  
		  
		  
		  
		  
          
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
          
      $('.homeslider').slick({
        autoplay: true,
        autoplaySpeed: 7000,
        arrows: true,
          fade: true,
          dots: true
      });            
          
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about': {
      init: function() {
          
          
          
          
   
          
          
  
$('#photoGallery').on('shown.bs.modal', function () {
    
var $status = $('.pagingInfo');
var $slickElement = $('.about-slider');

$slickElement.on('init reInit afterChange', function (event, slick, currentSlide, nextSlide) {
     
    setTimeout(function(){ 
        $('.sliderloader').fadeOut('fast');
    }, 1000);

    var i = (currentSlide ? currentSlide : 0) + 1;
    $status.text(i + '/' + slick.slideCount);
    
}); 

// Intro Slider
$(".about-slider").slick({
    // autoplay: true,
    dots: false,
    appendArrows: $('.arrows'),
    responsive: [{ 
    breakpoint: 480,
        settings: {
        dots: false,
        arrows: false,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1
        } 
    }]
});   


});    
          
        
          
          

          
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
